import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Controls from './components/Controls';
import Layout from './components/Layout';
import createTime from './utils/time';

import './scss/style.scss';

const UNKNOWN_WIDTH = -1;

class Timeline extends Component {
    constructor(props) {
        super(props);
        const timelineViewportWidth = UNKNOWN_WIDTH;
        const sidebarWidth = UNKNOWN_WIDTH;
        this.state = {
            time: createTime({ ...props.scale, viewportWidth: timelineViewportWidth }),
            timelineViewportWidth,
            sidebarWidth,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scale } = this.props;
        const { timelineViewportWidth } = this.state;

        if (nextProps.scale !== scale) {
            const time = createTime({
                ...nextProps.scale,
                viewportWidth: timelineViewportWidth,
            });
            this.setState({ time });
        }
    }

    handleLayoutChange = ({ timelineViewportWidth, sidebarWidth }, cb) => {
        const { scale } = this.props;
        const time = createTime({
            ...scale,
            viewportWidth: timelineViewportWidth,
        });
        this.setState(
            {
                time,
                timelineViewportWidth,
                sidebarWidth,
            },
            cb
        );
    };

    render() {
        const {
            showHeader = true,
            isOpen = true,
            toggleOpen,
            zoomIn,
            zoomOut,
            scale: { zoom, zoomMin, zoomMax },
            tracks,
            now,
            timebar,
            toggleTrackOpen,
            enableSticky = false,
            scrollToNow,
            showControls = false,
            style = {},
            onDragStart,
            dragAndDropReservation,
            onDrop,
        } = this.props;
        const { time, timelineViewportWidth, sidebarWidth } = this.state;
        const { clickElement, clickTrackButton, trackButtonIcon, onCellClick } = this.props;

        return (
            <div className="rt">
                {showControls ? (
                    <Controls
                        isOpen={isOpen}
                        toggleOpen={toggleOpen}
                        zoomIn={zoomIn}
                        zoomOut={zoomOut}
                        zoom={zoom}
                        zoomMin={zoomMin}
                        zoomMax={zoomMax}
                    />
                ) : null}
                <Layout
                    showHeader={showHeader}
                    style={style}
                    enableSticky={enableSticky}
                    now={now}
                    tracks={tracks}
                    timebar={timebar}
                    toggleTrackOpen={toggleTrackOpen}
                    scrollToNow={scrollToNow}
                    time={time}
                    isOpen={isOpen}
                    onLayoutChange={this.handleLayoutChange}
                    timelineViewportWidth={timelineViewportWidth}
                    sidebarWidth={sidebarWidth}
                    clickElement={clickElement}
                    clickTrackButton={clickTrackButton}
                    trackButtonIcon={trackButtonIcon}
                    onDragStart={onDragStart}
                    dragAndDropReservation={dragAndDropReservation}
                    onDrop={onDrop}
                    onCellClick={onCellClick}
                />
            </div>
        );
    }
}

Timeline.propTypes = {
    scale: PropTypes.shape({
        start: PropTypes.instanceOf(Date).isRequired,
        end: PropTypes.instanceOf(Date).isRequired,
        zoom: PropTypes.number.isRequired,
        zoomMin: PropTypes.number,
        zoomMax: PropTypes.number,
        minWidth: PropTypes.number,
    }),
    style: PropTypes.object,
    isOpen: PropTypes.bool,
    toggleOpen: PropTypes.func,
    zoomIn: PropTypes.func,
    zoomOut: PropTypes.func,
    clickElement: PropTypes.func,
    clickTrackButton: PropTypes.func,
    trackButtonIcon: PropTypes.element,
    timebar: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tracks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    now: PropTypes.instanceOf(Date),
    toggleTrackOpen: PropTypes.func,
    enableSticky: PropTypes.bool,
    scrollToNow: PropTypes.bool,
    showControls: PropTypes.bool,
};

export default Timeline;
